import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import Layout from "./layout";

export const Dashboard = ({ addresform }) => {
  const history = useHistory();

  useEffect(() => {
    if (addresform) {
      history.push("/dealers/winer");
    }
  }, [addresform, history]);

  return <Layout />;
};

const mapStateToProps = (state) => ({
  addresform: state.shiping.addresform,
});

export default connect(mapStateToProps)(Dashboard);
